<template>
  <div class="c-scenarios">
    <panel-header title="Сценарии" :with-back-button="true" @back="back" />
    <div class="c-scenarios__container" v-loading="loading">
      <div class="c-scenarios__controls">
        <div class="c-scenarios__control">
          <el-button class="r-button" @click="createScenario" type="primary">
            Новый сценарий
          </el-button>
        </div>
      </div>
      <div class="c-scenarios__filter">
        <el-input
          prefix-icon="el-icon-search"
          class="r-input"
          v-model="filter"
          placeholder="Поиск по названию сценария"
        />
        <r-radio-group
          style="margin-top: 16px"
          :button-list="scenarioTypes"
          :active="activeType"
          @change="changeType"
        />
      </div>
      <template>
        <r-simple-list
          v-if="filteredScenarios.length"
          style="margin: 8px"
          :list="filteredScenarios"
          @click-handler="clickHandler"
        />
        <div v-else class="c-models__nodata">
          <r-text type="caption">
            Нет ни одного сценария с данным статусом
          </r-text>
        </div>
      </template>
    </div>

    <c-help :title="helpTitle" :text="helpText" />
  </div>
</template>

<script>
import moment from "moment";
import PanelHeader from "@/components/calculations/panel-header/panel-header";
import CHelp from "@/components/calculations/help/help";

const scenarioTypes = [
  { id: "done", label: "Готовые" },
  { id: "in_progress", label: "В процессе" },
  { id: "draft", label: "Черновики" }
];

export default {
  components: {
    PanelHeader,
    CHelp
  },
  data() {
    return {
      scenarios: [],
      filter: "",
      loading: false,
      activeType: "done",
      scenarioTypes
    };
  },
  computed: {
    model() {
      return this.$store.state.calculations.model;
    },
    filteredScenarios() {
      return this.scenarios
        .filter(
          m => m.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
        )
        .filter(({ status }) => status === this.activeType);
    },
    helpTitle() {
      switch (this.activeType) {
        case "done":
          return "Рассчитанные сценарии";
        case "in_progress":
          return "Сценарии в расчёте";
        case "draft":
          return "Черновик сценария";
        default:
          return "";
      }
    },
    helpText() {
      switch (this.activeType) {
        case "done":
          return "В таких сценариях вы не можете изменять и добавлять события, но можете настраивать отображение результатов. Для этого выберите нужный слой в панели слева";
        case "in_progress":
          return "Пока сценарий рассчитывается, вы не можете производить с ним никаких действий, кроме просмотра его содержимого";
        case "draft":
          return "Черновик – это сценарий, не запущенный в расчёт, его можно редактировать или удалить";
        default:
          return "";
      }
    }
  },
  methods: {
    back() {
      if (this.$store.state.calculations.loadingLayers.length) return;

      this.$router.push("/app/calculations");
    },
    changeType(value) {
      this.activeType = value;
    },
    createScenario() {
      const { modelId } = this.$route.params;

      this.$router.push(`/app/calculations/${modelId}/editor`);
    },
    async getScenarios() {
      try {
        this.loading = true;
        const { id } = this.model;
        const url = `branch/${id}?format=list`;
        await this.$store.dispatch("POST_REQUEST", {
          url: `branch/${id}`,
          data: { branch_id: null }
        });
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.scenarios = Object.values(data).map(s => ({
          ...s,
          title: s.name,
          subtitle: this.getScenarioSubtitle(s),
          icon: this.getScenarioIcon(s.status)
        }));
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    socketHandler() {
      this.getScenarios();
    },
    async moveToBranch(branch_id) {
      const { modelId } = this.$route.params;
      const url = `branch/${modelId}`;
      const data = { branch_id };

      await this.$store.dispatch("POST_REQUEST", { url, data });
    },
    async clickHandler({ id, name, status }) {
      const { modelId } = this.$route.params;

      await this.moveToBranch(id);

      switch (status) {
        case "draft":
          return this.$router.push(
            `/app/calculations/${modelId}/editor?id=${id}`
          );
        case "done":
          this.$store.commit("SET_CALC_FIELD", {
            field: "currentScenarioId",
            value: id
          });
          this.$store.commit("SET_CALC_FIELD", {
            field: "currentScenarioName",
            value: name
          });

          return this.$router.push(`/app/calculations/${modelId}/${id}`);
        default:
          return;
      }
    },
    parseTime(time) {
      return moment(time).format("YYYY/MM/DD HH:mm:ss");
    },
    getScenarioSubtitle(scenario) {
      const {
        status,
        branch_timestamp,
        calculation_start_time,
        calculation_end_time
      } = scenario;

      switch (status) {
        case "draft":
          return `Создан ${this.parseTime(branch_timestamp)}`;
        case "in_progress":
          return `Запущен ${this.parseTime(calculation_start_time)}`;
        default:
          return `Завершен ${this.parseTime(calculation_end_time)}`;
      }
    },
    getScenarioIcon(status) {
      switch (status) {
        case "draft":
          return "edit-zone";
        case "in_progress":
          return "in-process";
        default:
          return "success";
      }
    }
  },
  async created() {
    this.getScenarios();

    this.$socket.on("worker", this.socketHandler);
  },
  beforeDestroy() {
    this.$socket.off("worker", this.getScenarios);
  }
};
</script>

<style lang="scss">
.c-scenarios {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 48px);
  width: 260px;
  position: relative;

  &__controls {
    padding: 8px;
    border-bottom: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;

    .r-button {
      width: 100%;
    }
  }

  &__filter {
    padding: 8px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
  }

  &__list {
    flex: 1;
    overflow: auto;
    height: 0px;
  }
}
</style>
